export const APP_NAME = 'Sooth Organics';
export const ADDRESS = 'Jetalpur Pirana Rd, Ahmedabad, Giramtha, Gujarat 382425';
export const MOBILE = '7567018165';
export const EMAIL = 'connectwithus@sootheorganics.in';
export const ADDRESS_MAP = "https://maps.app.goo.gl/FnswcGVWgP78ahAu5?g_st=iw";
export const MAP_API_KEY = "AIzaSyBEK-SmhUYt64BnQSdvojJSJKYx7HY0mBM";
